import styled from 'styled-components';
import { statusKeys } from '../Funds/consts';

const statusColors = {
  [statusKeys.READY]: {
    text: '#37AB6E',
    bg: '#37AB6E33'
  },
  [statusKeys.SUBMITTED]: {
    text: '#276EF1',
    bg: '#276EF133'
  },
  [statusKeys.ERROR]: {
    text: '#DE1135',
    bg: '#DE113533'
  }
};

export const Wrapper = styled.div`
  min-width: 750px;
  width: 750px;
  border-radius: 24px;
  background-color: #edf0f5;
  padding: 16px;
  overflow: hidden;
`;

export const Body = styled.div`
  width: 100%;
  border-radius: 12px;
  background-color: #fff;
  padding: 40px;

  .badge {
    margin: 10px 0;
    width: 380px;
  }
`;

export const SelectAllStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 26px;
  margin-bottom: 10px;
  p {
    color: #2b313d;
    font-size: 16px;
    font-weight: 500;
  }
  .select-all {
    color: #2b313d;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  justify-content: flex-end;
  button {
    width: 25%;
  }
`;

export const Title = styled.div`
  color: #5c5d61;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  padding-bottom: 12px;
  border-bottom: 2px solid #cdd4df;
`;

export const FundsContainer = styled.div`
  background-color: #f3f3ff;
  border-radius: 6px;
`;

export const Funds = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  height: 400px;
  padding: 12px;
  overflow: auto;
`;

export const FundItem = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #5c5d61;
  font-size: 16px;
  border-radius: 6px;
  ${({ disabled }) => disabled && 'opacity: 0.7;'};
  ${({ disabled }) => `cursor: ${disabled ? 'auto' : 'pointer'};`};

  & > svg {
    flex-shrink: 0;
  }

  .status-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    font-size: 14px;
    line-height: 18px;
    ${({ status }) => `color: ${statusColors[status].text};`};
    ${({ status }) => `background-color: ${statusColors[status].bg};`};
    white-space: nowrap;
    gap: 4px;
    padding: 4px 6px;
    margin-left: auto;

    svg {
      width: 16px;
      height: 16px;

      path {
        ${({ status }) => `stroke: ${statusColors[status].text};`};
      }
    }
  }
`;
